module.exports = __webpack_public_path__ + "static/back-a225365b09b159729c75d1f62aa40fbb.webm";